import React from 'react';
import { uuid } from '../../../utils/utils';
import EventSequence from '../../../@types/event-sequence';
import EventSequenceService from '../../../services/event-sequence.service';
import JointJsCanvasEditor from './JointJsCanvasEditor';
import PanelDna from './canvas/PanelDna';
import PanelODnaList from './canvas/PanelODnaList';
import { toast } from 'react-toastify';
import {EventSequenceSummaryEditorProps} from '../../../@types/editor-props';
import {CanvasActionType} from '../../../@types/canvas-action-type';
import { useWorkspaceContext } from '../../../context/workspaceContext';
import SplitPane, { SashContent} from 'split-pane-react';

export default function EventSequenceTreeEditor(props: EventSequenceSummaryEditorProps): React.ReactElement {
    const { eventSequenceSummary, updateTab, isActive } = props;
    const [eventSequence, setEventSequence] = React.useState<EventSequence>({ id: 0 } as EventSequence);
    const uuidRef = React.useRef(uuid());
    const { setCurrentCanvasAction } = useWorkspaceContext();
    const [panelSizePercent, setPanelSizePercent] = React.useState<(number | string)[]>(['0%', '100%', '0%']);

    const toggleDnaPane = (openDnaPanel: boolean | string[]): void => {
        let newSizePercent = [...panelSizePercent];
        if (!Array.isArray(openDnaPanel) && typeof openDnaPanel === 'boolean') {
            if (openDnaPanel) {
                newSizePercent[1] = '75%';
                newSizePercent[2] = '25%';
            } else {
                newSizePercent[1] = '100%';
                newSizePercent[2] = '0%';
            }
            setPanelSizePercent(newSizePercent);
        } else {
            setPanelSizePercent(openDnaPanel);
        }
    };

    const toggleODnaListPanel = (openODnaListPanel: boolean | string[]): void => {
        let newSizePercent = [...panelSizePercent];
        if (!Array.isArray(openODnaListPanel) && typeof openODnaListPanel === 'boolean') {
            if (openODnaListPanel) {
                newSizePercent[0] = '25%';
                newSizePercent[1] = '75%';
            } else {
                newSizePercent[0] = '0%';
                newSizePercent[1] = '100%';
            }
            setPanelSizePercent(newSizePercent);
        } else {
            setPanelSizePercent(openODnaListPanel);
        }
    };

    React.useEffect(() => {
        if (isActive) {
            setCurrentCanvasAction({ actionType: CanvasActionType.CANVAS_REFRESH });
        }
    }, [isActive]);

    React.useEffect(() => {
        EventSequenceService.getEventSequenceById(eventSequenceSummary.id).then((response) => {
            setEventSequence(response);
        }).catch((error: Error) => {
            toast.error(error.message);
        });
    
    }, [eventSequenceSummary]);

    return <div id={uuidRef.current} style={{ width: '100vw', height: 'calc(100vh - 220px)', maxWidth: '100%', maxHeight: '100%', overflow: 'hidden' }}>
        <SplitPane
            split="vertical"
            sizes={panelSizePercent}
            onChange={setPanelSizePercent}
            sashRender={(index: number, active: boolean): React.ReactNode => (
                <SashContent
                    className={active ? 'action-sash-wrap' : 'hidden-sash'}
                >
                </SashContent>
            )}
        >
            <PanelODnaList eventSequence={eventSequence} isActive={isActive}  onDnaToggle={toggleODnaListPanel}/>
            <JointJsCanvasEditor eventSequence={eventSequence} isActive={isActive} readonly={false} updateTab={updateTab}/>
            <PanelDna eventSequence={eventSequence} isActive={isActive}  onDnaToggle={toggleDnaPane}/>
        </SplitPane>
        
    </div>;
}

